
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
    position: relative;
    display: block
}
.tab-panel-button {
    cursor: pointer;
    border-radius: 0.75rem;
    border-width: 1px;
    font-weight: var(--fw-semibold);
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms
}
.tab-panel-button.inactive:hover, .tab-panel-button.active {
    border-color: var(--primary-blue);
    background-color: var(--primary-blue);
    color: var(--neutral-white)
}
.tab-panel-button.inactive {
    border-color: var(--primary-blue);
    background-color: var(--neutral-white);
    color: var(--primary-blue)
}
.tab-panel-content.mobile {
    padding-left: 1rem;
    padding-right: 1rem
}
.tab-panel-label.mobile {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
`;